import { InternalScenarios } from '@regulaforensics/vp-frontend-document-components';

export const getManualIdScanSettings = (): Record<string, unknown> => {
  return {
    startScreen: true,
    changeCameraButton: true,
    multipageProcessing: false,
    internalScenario: InternalScenarios.MrzOrLocate,
    copyright: false,
    mirrorType: 'mirror',
  };
};
